import RequisitionPage from "./requisition.react";
import RequisitionFormPage from "./requisition-form.react";
import RequisitionItemPage from "./item.react";
import RequisitionItemFormPage from "./item-form.react";
import RequisitionReportPage from "./report.react";

export const RequisitionSettings = {
  pagePathKey: 'requisitionPagePath',
  alertKey: 'requisitionAlert'
};

export {
  RequisitionPage,
  RequisitionFormPage,
  RequisitionItemPage,
  RequisitionItemFormPage,
  RequisitionReportPage
};



// WEBPACK FOOTER //
// ./src/requisition/index.js